import type { BannerFixoProps } from "../../banner-fixo.props"
import { slugify } from "@/utils/slugify"
import { ContentBanner } from "./ContentBanner"
import { CountDown } from "./countDown/CountDown"

interface ConteudoBannerProps {
    data: {
        banner: BannerFixoProps
        device: number
    }
}

export default function ConteudoBanner({ data }: Readonly<ConteudoBannerProps>) {

    const banner = data.banner

    return (
        <div
            data-promo-id={slugify(banner.nome_promocao)}
            className="banner-img banner-promo"
            data-promo-name={banner.nome_promocao}
            data-tipo={banner.tipo}
            data-creative-name={banner.titulo}
        >
            <ContentBanner banner={banner}>

                {banner.url_video_banner && (
                    <video
                        src={banner.url_video_banner}
                        className="lazyload"
                        preload="none"
                        data-autoplay=""
                        muted
                        loop
                        playsInline
                    />
                )}

                {banner.url_midia_banner && (
                    <img
                        className="lazyload"
                        src={banner.url_hint_banner}
                        data-src={banner.url_midia_banner}
                        alt={banner.midia_alt}
                        title={banner.legenda ? banner.legenda : banner.midia_title}
                        width={banner.midia_opcoes?.width || ''}
                        height={banner.midia_opcoes?.height || ''}
                    />
                )}

                {(banner.timer && banner.data_inicio && banner.data_fim) && (
                    <CountDown data={data} refresh={true} />
                )}

            </ContentBanner>

        </div>
    )
}
